import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import loginReducer from './loginReducer';
import emisorReducer from './emisorReducer';
import { cantones, distritos, barrios } from './ubicacionReducer';
import { allActividadesReducer, actividadesReducer } from './actividadesReducer';
import facturasReducer,
{
    direccionEmisor,
    direccionReceptor,
    duplicarFactura,
    confirmacionFacturas,
    getDocumentosConfirmados,
    getFacturaCompraPorEmisor
} from './facturasReducer';
import { cabys, inventario, searchCabys } from './inventarioReducer';
import { localFormReducer } from './localFormReducer';
import { tipoCambioDolar } from './tipoCambioReducer';
import { receptoresByEmisorReducer, getReceptorHaciendaReducer } from './receptorReducer';
import { isLoading } from './loadingReducer';
import { validarExoneracion } from './validarExoneracionReducer';
import { getNuevoDocumentoErrores, getErrores } from "./errorReducer";
import { getNotaCreditoPorEmisor } from './notaCreditoReducer';
import { estadoDocumentoElectronico } from './estadoDocumentoElectronico';
import { getNotaDebitoPorEmisor } from './notaDebitoReducer';
import { getTiquetePorEmisor } from './tiquetesReducer';
import { dashboardReducer } from './dashboardReducer';


export default combineReducers({
    isLoadingState: isLoading,
    loginState: loginReducer,
    form: formReducer,
    emisorState: emisorReducer,
    cantonesState: cantones,
    distritosState: distritos,
    barriosState: barrios,
    errorState: getErrores,
    nuevoDocumentoErroresState: getNuevoDocumentoErrores,
    allActividadesState: allActividadesReducer,
    actividadesState: actividadesReducer,
    cabysState: cabys,
    inventarioState: inventario,
    localFormState: localFormReducer,
    tipoCambioDolarState: tipoCambioDolar,
    receptoresByEmisorState: receptoresByEmisorReducer,
    exoneracionState: validarExoneracion,
    searchCabys: searchCabys,
    confirmacionFacturasState: confirmacionFacturas,
    getConfirmadosState: getDocumentosConfirmados,
    duplicarFacturaState: duplicarFactura,
    direccionEmisorState: direccionEmisor,
    direccionReceptorState: direccionReceptor,
    facturasState: facturasReducer,
    estadoDocumentoElectronicoState: estadoDocumentoElectronico,

    notasCreditoState: getNotaCreditoPorEmisor,
    notasDebitoState: getNotaDebitoPorEmisor,
    tiquetesState: getTiquetePorEmisor,
    dashboardState: dashboardReducer,
    facturaCompraState: getFacturaCompraPorEmisor,

    receptorHaciendaState: getReceptorHaciendaReducer,
});